import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';

import ContentContainer from '@app/components/ContentContainer';
import MainPageHeader from '@app/components/MainPageHeader';
import { useMainPageHeaderState } from '@app/hooks/useMainPageHeaderState';
import { useWorkspace } from '@app/hooks/workspace';

import DocumentManagementButton from '../DocumentManagementButton';
import UploadPageLinkButton from '../UploadPageLinkButton';

interface ExternalDocumentMainLayoutProps {
  children: ReactNode;
}

export default function ExternalDocumentMainLayout({ children }: ExternalDocumentMainLayoutProps) {
  const workspace = useWorkspace();
  const [{ externalDocuments: tabIndex }, setTabIndex] = useMainPageHeaderState();

  return (
    <ContentContainer>
      <MainPageHeader
        tab={
          workspace.type === 'PUBLIC'
            ? {
                tabs: ['전체', '내 계약'],
                index: tabIndex,
                onChange: (value) => setTabIndex({ externalDocuments: value }),
              }
            : undefined
        }
        title="외부문서함"
      >
        <DocumentManagementButton sx={{ height: '36px', mr: 5, flex: 'none' }} />
        <UploadPageLinkButton />
      </MainPageHeader>
      <Box px={[0, null, 9]} py={[0, null, 7]}>
        {children}
      </Box>
    </ContentContainer>
  );
}
